import { AxiosError } from "axios";

export const errorInterceptor = (error: AxiosError) => {
  console.error("Error intercepted:", error);
  if (error.response?.status === 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("permissions");
    localStorage.removeItem("idUserLogado");
    localStorage.removeItem("idCompany");
    localStorage.removeItem("avatar");
    localStorage.removeItem("fullName");

    // Isso fará com que o Login() volte a ser exibido automaticamente
  }

  return Promise.reject(error);
};